<template lang="pug">
  .card__wrapper.box__shadow(
    :style="specificStyles"
  )
    section(
      style="width:100%"
    )
      // h3 {{displayName === 'Training Media' ? (media ? media.title : '') : displayName}}
      div(
        v-if="getActiveMedia && getActiveMedia.status"
        :style="styles.mediaContainer"
      )
        MediaCard(
          :contentType="getActiveMedia.type"
          :onClick="toggleAddMediaToCardModal"
          :title="getActiveMedia.title"
          :isActiveItem="true"
          :isActionCard="true"
          :src="getActiveMedia.thumbnail"
          :content="getActiveMedia.contentType"
          :cardSpecificStyles="{ width: '100%' }"
          :viewSpecificStyles="{ width: '100%', boxShadow: 'none' }"
          :isMediaLibrary="false"
        )
      div.no-media-box(
        v-if="(media && !media.status) || getActiveCard.mediaId && !getActiveMedia || ((getActiveCard.cardType.name === 'media' || getActiveCard.cardType.name === 'message') && !getActiveMedia)"
      )
        button.button__action(
          @click="toggleAddMediaToCardModal"
        ) Add Media
      div.no-media-box(
        v-if="fields.includes('icon') && !getActiveLocalRecord.cardImageUrl"
      )
        button.button__action(
          @click="toggleAddIconToCardModal('cardImageUrl')"
        ) Add Image
      div(
        v-if="fields.includes('icon') && getActiveLocalRecord.cardImageUrl"
      )
        img.card-icon(
            @click="toggleAddIconToCardModal('cardImageUrl')"
            :src="getActiveLocalRecord.cardImageUrl"
        )
      div(
        v-if="fields.includes('title')"
      )
        MixedContentInput(
          :template="shortId"
          :activeSetting="activeSetting"
          :isEditing="isEditing"
          section="title"
          :content="getActiveLocalRecord.title || '(no content)'"
          :paramOptions="params"
          :edit="checkEdits"
        )
      div(
        v-if="fields.includes('callToAction')"
      )
        MixedContentInput(
          :template="shortId"
          :isEditing="isEditing"
          :activeSetting="activeSetting"
          section="callToAction"
          :content="callToAction || '(no content)'"
          :paramOptions="params"
          :edit="checkEdits"
        )
      .label(
        v-if="fields.includes('label')"
      )
        label Label
        input(
            v-model="getActiveLocalRecord.label"
            type="text"
            placeholder="Label"
        )
      .link-list(
          v-if="fields.includes('socialLinks')"
      )
        label Link List
        .link-item(
            v-for="(link, index) in getActiveLocalRecord.socialLinks"
        )
            .link-icon
                label Icon
                img(
                    :src="getActiveLocalRecord.socialLinks[index].icon"
                    v-if="getActiveLocalRecord.socialLinks[index].icon"
                )
                button.button__action(
                    @click="toggleAddIconToCardModal(index)"
                    v-if="!getActiveLocalRecord.socialLinks[index].icon"
                ) Add Icon
            .link-text
                label Text
                input(
                    v-model="getActiveLocalRecord.socialLinks[index].text"
                    type="text"
                )
            .link-url
                label Url
                input(
                    v-model="getActiveLocalRecord.socialLinks[index].url"
                    type="text"
                )
            .link-delete(
                @click="removeLinkItem(index)"
            ) X
        button.button__action.add-link(
            @click="addSocialLink"
            v-if="!getActiveLocalRecord.socialLinks || getActiveLocalRecord.socialLinks.length < 6"
        ) Add Link
      div.action-button(
        v-if="fields.includes('buttonText')"
      )
        div
            label Action Button Text
            input(
                v-model="getActiveLocalRecord.actionButton[activeSetting]"
                type="text"
            )
        div
            label Action Button URL
            input(
                v-model="getActiveLocalRecord.actionUrl"
                type="text"
            )

      div.no-media-box(
        v-if="fields.includes('triggerContextImage') && !getActiveLocalRecord.trigger.imageUrl"
      )
        button.button__action(
          @click="toggleAddIconToCardModal('trigger')"
        ) Add Trigger Context Image
      .trigger-context-image(
        v-if="fields.includes('triggerContextImage') && getActiveLocalRecord.trigger"
      )
        img.card-icon(
            @click="toggleAddIconToCardModal('trigger')"
            :src="getActiveLocalRecord.trigger.imageUrl"
        )
        label(
            v-if="!getActiveLocalRecord.trigger.contextType === 'imageonly'"
        ) Trigger Context Url
        input(
            v-if="!getActiveLocalRecord.trigger.contextType === 'imageonly'"
            v-model="getActiveLocalRecord.trigger.url"
            type="text"
        )
    .label
      label Background URL
      MixedContentInput(
          :template="shortId"
          :isEditing="isEditing"
          :activeSetting="activeSetting"
          section="backgroundUrl"
          :content="getActiveLocalRecord.backgroundUrl || '(no content)'"
          :paramOptions="params"
          :edit="checkEdits"
      )
    footer(
      v-if="fields.includes('help')"
      style="align-self:flex-end; width:100%;"
    )
      div(
        @click="toggleFooterPopup"
        class="togglePopupButton"
        :style="styles.cardFooter"
      )
        a.footer__link(
          @click="showHelpModal"
          :href="helpUrl"
          target="_blank"
        ) {{getActiveLocalRecord.help && getActiveLocalRecord.help.text ? getActiveLocalRecord.help.text : '(no content)'}}
</template>
<script>
import MixedContentInput from './MixedContentInput';
import VueNotifications from 'vue-notifications';
import MediaCard from './MediaCard';
import Services from '../../services/Services';
import store from '../../store';
export default {
  name: 'ActionCard',
  components: {
    MediaCard,
    MixedContentInput
  },
  props: {
    activeSetting: String,
    body: String,
    callToAction: String,
    checkEdits: Function,
    helpText: String,
    displayName: String,
    helpUrl: String,
    isEditing: Boolean,
    media: [Object, Boolean],
    subject: String,
    title: String,
    params: Array,
    fields: Array,
    specificStyles: Object,
    backgroundUrl: String,
  },
  computed: {
    getActiveCard() {
      return store.getters.getActiveCard;
    },
    getActiveMedia() {
      return store.getters.getActiveMedia;
    },
    getActiveLocalRecord() {
      return store.getters.getActiveLocalRecord;
    },
  },
  methods: {
    cleanParams(paramStr) {
      const arr = paramStr.match(/{(.*?)}/g) || [];
      const sanitized = arr.map(param => param.substring(1, param.length - 1));
      return sanitized;
    },
    toggleFooterPopup() {
      this.showFooterPopup = !this.showFooterPopup;
    },
    showHelpModal(){
      store.commit('showCardHelpModal', true);
    },
    toggleAddIconToCardModal(context, index) {
        console.log('opening social link modal')
        if(index) {
            console.log('specific social link')
            store.commit('setCardIconContext', socialLinks[index])
        } else {
            store.commit('setCardIconContext', context);
        }
        Services.toggleAddIconToCard(true);
    },
    addSocialLink(){
        const emptyLink = {icon: '', text: '', url: ''}
        if(!this.getActiveLocalRecord.socialLinks){
            this.getActiveLocalRecord.socialLinks = [emptyLink];
        } else {
            this.getActiveLocalRecord.socialLinks.push(emptyLink);
        }
    },
    removeLinkItem(index){
        this.getActiveLocalRecord.socialLinks.splice(index, 1);
    }
  },
  data(){
    return {
      shortId: this.$route.params.shortId,
      showFooterPopup: false,
      toggleAddMediaToCardModal: Services.toggleAddMediaToCard,
      styles: {
        cardFooter: {
          display: 'flex',
          margin: 'auto 0 0',
          padding: '20px 10px 40px',
          fontSize: '1.1em',
          flexFlow: 'column nowrap',
          alignItems: 'center'
        },
        mediaContainer: {
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          position: 'relative',
        }
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  }
}
</script>
<style lang="scss" scoped>
.card__wrapper{
  background: #FFF;
  max-width: 500px;
  width: 500px;
  padding: 2rem 1rem;
  min-height: 560px;
  display: flex;
  // margin: 0 auto 40px;
  justify-content: space-between;
  flex-flow: column nowrap;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #eee;
  font-family: 'proxima_nova_ltsemibold', Arial, Helvetica, sans-serif;
  text-align: center;
  // min-height: 75vh;

  h3 {
    font-family: 'proxima_nova_ltsemibold', Arial, Helvetica, sans-serif;
    font-weight: normal;
  }

  .footer__link {
    color: #09a3ed;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    width: 100%;
  }
}

section {
  font-family: 'proxima_nova_rgregular';
}

.no-media-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed #CCC;
  height: 250px;
  margin-bottom: 10px;
}

.card-icon {
    max-width: 100%;
    margin: 0 auto 1rem;
}

.label{
    width: 100%;

    > * {
        text-align: left;
        display: block;
        width: 100%;
    }

    input {
        height: 34px;
    }

    label {
        margin-bottom: 5px;
    }
}

.card-icon {
    cursor: pointer;
}

.link-list {
    margin-top: 1rem;
    width: 100%;

    > div {
        display: flex;
        flex-direction: row;

        input {
            height: 34px;
            width: 100%;
        }

        .link-icon {
            padding-right: 5px;
            width: 20%;

            button {
                margin: 0;
            }

            img {
                max-width: 100%;
            }
        }

        .link-text {
            padding-right: 5px;
            width: 30%;
        }

        .link-url {
            width: 47%;
        }

        .link-delete {
            position: relative;
            top: 26px;
            left: 7px;
            width: 3%;
        }
    }

    .link-item {
        margin-top: 10px;
    }

    label {
        text-align: left;
        display: block;
    }

    .add-link {
        margin: 1.6rem 0 0;
    }
}

.trigger-context-image, .action-button {
    display: block;
    width: 100%;
    label {
        text-align: left;
        display: block;
    }

    input {
        display: block;
        width: 100%;
        height: 34px;
        margin: 5px 0 0;
    }
}

.action-button input {
    margin-bottom: 1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/general/ActionCard.vue